<template>
  
  <div>
    <div class="d-flex justify-end">
      <memlist-icon-button
        class="mb-2"
        icon="menu-icon flaticon2-plus"
        :text="$t('PAGES.REGISTRATION.NEW_PAGE')"
        variant="primary"
        @click="createPageClicked"
      />
    </div>

    <memlist-static-table
      id="pages-table"
      :fields="headers"
      :items="items"
    >
      <template #cell(type)="row">
        <span class="d-block font-size-lg">{{ getTypeString(row.item.type) }}</span>
      </template>
      <template #cell(id)="row">
        <div class='justify-content-end d-flex'>
          <memlist-table-button class="mr-2" @click="moveUpClicked(row.item.id)" icon="fa fa-arrow-up" :tooltip="$t('PAGES.REGISTRATION.MOVE_UP')" />
          <memlist-table-button class="mr-2" @click="moveDownClicked(row.item.id)" icon="fa fa-arrow-down" :tooltip="$t('PAGES.REGISTRATION.MOVE_DOWN')" />
          
          <memlist-table-button class="mr-2" @click="selectPageClicked(row.item.id)" svg="/assets/svg/pencil-square.svg" :tooltip="$t('PAGES.REGISTRATION.EDIT_PAGE')" />
          <memlist-table-button class="mr-2" @click="deletePageClicked(row.item.id)" svg="/assets/svg/trash2.svg" :tooltip="$t('PAGES.REGISTRATION.DELETE_PAGE')" />

        </div>
      </template>
    </memlist-static-table>
  </div>
</template>

<script>
import axios from 'axios';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';

export default {
  name: 'PagesTable',
  mixins: [ toasts ],
  props: ['items', 'currentCompanyId', 'types'],
  emits: ['createPageClicked', 'selectPageClicked', 'deletePageClicked', 'moveUpClicked', 'moveDownClicked', 'show_history_toggled'],
  components: {
    
  },
  watch: {
    show_history(newcheck, oldcheck) {
      this.$emit('show_history_toggled', newcheck);
    },
    items(newValue, oldValue) {
      const iFamily = newValue.findIndex(item => item.type === 'reg_family');
      const iDetails = newValue.findIndex(item => item.type === 'details');
      const iPersonnr = newValue.findIndex(item => item.type === 'personnr');
      const iStudent = newValue.findIndex(item => item.type === 'student');
      const iConfirm = newValue.findIndex(item => item.type === 'confirm');
      const iShop = newValue.findIndex(item => item.type === 'shop');
      const iAreaAlloc = newValue.findIndex(item => item.type === 'area_alloc');
      const iProperties = newValue.findIndex(item => item.type === 'properties');
      const iParents = newValue.findIndex(item => item.type === 'parents');


      this.familyInvalid = iFamily !== -1 ? ( iShop === -1 || iFamily < iShop ) : false;
      this.personnrInvalid = iPersonnr !== -1 ? ( iDetails === -1 || iPersonnr > iDetails) : false;
      this.parentsInvalid = iParents !== -1 ? ( iDetails === -1 || iParents < iDetails) : false;
      this.shopInvalid = iShop !== -1 ? ( iAreaAlloc === -1 && iShop < iAreaAlloc ) : false;
      this.confirmInvalid = iConfirm !== -1 ? ( newValue.length !== iConfirm+1 ) : false;
    }
  },
  methods: {
    createPageClicked() {
      this.$emit('createPageClicked');
    },
    selectPageClicked(id) {
      this.$emit('selectPageClicked', id);
    },
    deletePageClicked(id) {
      this.$emit('deletePageClicked', id);
    },
    moveUpClicked(id) {
      this.$emit('moveUpClicked', id);
    },
    moveDownClicked(id) {
      this.$emit('moveDownClicked', id);
    },
    getTypeString(type) {
      return this.types[type];
    },

  },
  data() {
    return {
      familyInvalid: false,
      personnrInvalid: false,
      parentsInvalid: false,
      shopInvalid: false,
      confirmInvalid: false,
      show_history: false,
      headers: [
        {
          key: 'name',
          label: 'Namn',
          sortable: true,
          thClass: 'td-overflow',
          tdClass: 'td-overflow'
        },
        {
          key: 'type',
          label: 'Typ',
          thClass: 'td-short5',
          tdClass: 'td-short5',
          sortable: true
        },
        {
          key: 'id',
          label: '',
          thClass: 'td-short5',
        },
      ],
      list: []
    };
  }
};
</script>
